	export enum PatientAlertStatusEnum {
		New = 1,
		Completed = 2
	}
